export const LOCALSTORAGE = {
    ID_TOKEN: 'id_token'
};

export const MODAL_STYLE_RESET = {
    overlay: {
        position: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        backgroundColor: null
    },
    content: {
        position: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        border: null,
        background: null,
        overflow: null,
        WebkitOverflowScrolling: null,
        borderRadius: null,
        outline: null,
        padding: null
    }
};

export const STATES = [
    {value:"AL",label:"AL",country:"US"},
    {value:"AK",label:"AK",country:"US"},
    {value:"AZ",label:"AZ",country:"US"},
    {value:"AR",label:"AR",country:"US"},
    {value:"CA",label:"CA",country:"US"},
    {value:"CO",label:"CO",country:"US"},
    {value:"CT",label:"CT",country:"US"},
    {value:"DC",label:"DC",country:"US"},
    {value:"DE",label:"DE",country:"US"},
    {value:"FL",label:"FL",country:"US"},
    {value:"GA",label:"GA",country:"US"},
    {value:"HI",label:"HI",country:"US"},
    {value:"ID",label:"ID",country:"US"},
    {value:"IL",label:"IL",country:"US"},
    {value:"IN",label:"IN",country:"US"},
    {value:"IA",label:"IA",country:"US"},
    {value:"KS",label:"KS",country:"US"},
    {value:"KY",label:"KY",country:"US"},
    {value:"LA",label:"LA",country:"US"},
    {value:"ME",label:"ME",country:"US"},
    {value:"MD",label:"MD",country:"US"},
    {value:"MA",label:"MA",country:"US"},
    {value:"MI",label:"MI",country:"US"},
    {value:"MN",label:"MN",country:"US"},
    {value:"MS",label:"MS",country:"US"},
    {value:"MO",label:"MO",country:"US"},
    {value:"MT",label:"MT",country:"US"},
    {value:"NE",label:"NE",country:"US"},
    {value:"NV",label:"NV",country:"US"},
    {value:"NH",label:"NH",country:"US"},
    {value:"NJ",label:"NJ",country:"US"},
    {value:"NM",label:"NM",country:"US"},
    {value:"NY",label:"NY",country:"US"},
    {value:"NC",label:"NC",country:"US"},
    {value:"ND",label:"ND",country:"US"},
    {value:"OH",label:"OH",country:"US"},
    {value:"OK",label:"OK",country:"US"},
    {value:"OR",label:"OR",country:"US"},
    {value:"PA",label:"PA",country:"US"},
    {value:"RI",label:"RI",country:"US"},
    {value:"SC",label:"SC",country:"US"},
    {value:"SD",label:"SD",country:"US"},
    {value:"TN",label:"TN",country:"US"},
    {value:"TX",label:"TX",country:"US"},
    {value:"UT",label:"UT",country:"US"},
    {value:"VT",label:"VT",country:"US"},
    {value:"VA",label:"VA",country:"US"},
    {value:"WA",label:"WA",country:"US"},
    {value:"WV",label:"WV",country:"US"},
    {value:"WI",label:"WI",country:"US"},
    {value:"WY",label:"WY",country:"US"},
    {value:"AS",label:"AS",country:"US"},
    {value:"GU",label:"GU",country:"US"},
    {value:"MP",label:"MP",country:"US"},
    {value:"PR",label:"PR",country:"US"},
    {value:"UM",label:"UM",country:"US"},
    {value:"VI",label:"VI",country:"US"},
    {value:"AB",label:"AB",country:"CA"},
    {value:"BC",label:"BC",country:"CA"},
    {value:"MB",label:"MB",country:"CA"},
    {value:"NB",label:"NB",country:"CA"},
    {value:"NL",label:"NL",country:"CA","alt":["Newfoundland","Labrador"]},
    {value:"NS",label:"NS",country:"CA"},
    {value:"NU",label:"NU",country:"CA"},
    {value:"NT",label:"NT",country:"CA"},
    {value:"ON",label:"ON",country:"CA"},
    {value:"PE",label:"PE",country:"CA"},
    {value:"QC",label:"QC",country:"CA"},
    {value:"SK",label:"SK",country:"CA"},
    {value:"YT",label:"YT",country:"CA"}
];

export const SUBSCRIPTION_TYPES = [
    {
        label: 'Suspend Subscription',
        value: 'free'
    },
    {
        label: 'Business (###PRICE###)',
        value: 'annual'
    }
]

export const PROMO_CODE_VALUES = {
    bfdeal: '$500 off annual subscription'
};

export const SUBSCRIPTION_PRICES = {
    bfdeal: '$2000 per year'
}



// WEBPACK FOOTER //
// ./src/utils/constants.js